import deepClone from "@mna/utils/deepClone";

export default () =>
  deepClone({
    questionWithAnswers: [
      {
        presentQuestionsSelected: [],
        absentQuestionsSelected: [],
        unknownQuestionsSelected: [],
      },
    ],
    presentQuestionsSelected: [],
    absentQuestionsSelected: [],
    unknownQuestionsSelected: [],
    presentQuestionsSelectedTemp: [],
    absentQuestionsSelectedTemp: [],
    unknownQuestionsSelectedTemp: [],
    orderIdArray:[],
    answersArray: [],
    locationRiskfactors: []
  });
